module.exports = __webpack_public_path__ + "img/w79b.186d0abe.jpg";